import * as fieldDefinitionsSe from './se/fieldDefinitions';
import * as helpersSe from './se/helpers';
import * as fieldDefinitionsFi from './fi/fieldDefinitions';
import * as helpersFi from './fi/helpers';
import * as fieldDefinitionsNo from './no/fieldDefinitions';
import * as helpersNo from './no/helpers';
import { WizardStage } from '../MultiStageOnePageWizard/types';
import { TFunction } from 'i18next';
import { useMemo } from 'react';
import { CliFieldConfig } from './AmountVisualizer';
export * from './AmountVisualizer';

type ConfigMap = {
    'SE-CL': {
        in: fieldDefinitionsSe.SwedishLoanApplication;
        out: fieldDefinitionsSe.SwedishLoanApplication;
        config: undefined;
    };
    'SE-CLI': {
        in: fieldDefinitionsSe.SwedishLoanApplication;
        out: fieldDefinitionsSe.SwedishLoanApplicationCleaned;
        config: CliFieldConfig;
    };
    'FI-CL': {
        in: fieldDefinitionsFi.FinishLoanApplication;
        out: fieldDefinitionsFi.FinishLoanApplicationCleaned;
        config: helpersFi.ConfigType;
    };
    'FI-CLI': {
        in: fieldDefinitionsFi.FinishLoanApplication;
        out: fieldDefinitionsFi.FinishLoanApplicationCleaned;
        config: CliFieldConfig;
    };
    'NO-CL': {
        in: fieldDefinitionsNo.NorwegianLoanApplication;
        out: fieldDefinitionsNo.NorwegianLoanApplication;
        config: undefined;
    };
};

type Product = keyof ConfigMap;

export type WizardFormManager<T extends Product = Product> = {
    [P in T]: {
        initialValues: ConfigMap[P]['in'];
        getWizardStages: (t: TFunction, config?: ConfigMap[P]['config']) => WizardStage<ConfigMap[P]['in']>[];
        mapForSubmit: (values: ConfigMap[P]['in'], config?: ConfigMap[P]['config']) => ConfigMap[P]['out'];
    };
}[T];

type Configs<T extends Product = Product> = { [U in T]: WizardFormManager<U> };

const configs: Configs = {
    'SE-CL': {
        initialValues: fieldDefinitionsSe.initialValues,
        getWizardStages: helpersSe.getWizardStagesCl,
        mapForSubmit: helpersSe.cleanupFormValuesForSubmitting,
    },
    'SE-CLI': {
        initialValues: fieldDefinitionsSe.initialValues,
        getWizardStages: helpersSe.getWizardStagesCli,
        mapForSubmit: helpersSe.cleanupFormValuesForSubmittingCli,
    },
    'FI-CL': {
        initialValues: fieldDefinitionsFi.initialValues,
        getWizardStages: helpersFi.getWizardStagesCl,
        mapForSubmit: helpersFi.cleanupFormValuesForSubmitting,
    },
    'FI-CLI': {
        initialValues: fieldDefinitionsFi.initialValues,
        getWizardStages: helpersFi.getWizardStagesCli,
        mapForSubmit: helpersFi.cleanupFormValuesForSubmittingCli,
    },
    'NO-CL': {
        initialValues: fieldDefinitionsNo.initialValues,
        getWizardStages: helpersNo.getTranslatedStages,
        mapForSubmit: helpersNo.cleanupFormValuesForSubmitting,
    },
};

export function useWizardFormManager<P extends Product>(product: P): WizardFormManager<P> {
    return useMemo(() => configs[product], [product]);
}
